import template from './adpCircleIcon.html';
import controller from './adpCircleIcon.controller';
import './adpCircleIcon.less';

let adpCircleIconComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default adpCircleIconComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpCircleIcon/adpCircleIcon.component.js